import { initializeApp } from 'firebase/app';


// Set the configuration for your app
// TODO: Replace with your project's config object
const firebaseConfig = {
  apiKey: "AIzaSyDKNWHuzhe77RM69BmiPdAnSe5W1tsz7cI",
  authDomain: "projetocruzadinha.firebaseapp.com",
  databaseURL: "https://projetocruzadinha-default-rtdb.firebaseio.com/",
  storageBucket: "bucket.appspot.com",
};

const firebase = initializeApp(firebaseConfig);




export default firebase

